import { render } from "./ComentarPreenchido.vue?vue&type=template&id=00cfbe18"
const script = {}
script.render = render

export default script